import { getSafeUrl } from "../../../utils/helpers.js";
// import { Fragment, useState, useEffect } from "react";

// import { Modal, Spinner } from "react-bootstrap";
// import { useNavigate, useLocation } from "react-router-dom";
// import axios from "axios";

// import { useUserState } from "../../../Contexts/UserContext";

// import aboutUs from "../../../assets/images/about-us.png";
// import tickmark from "../../../assets/images/tickmark.svg";
// import furnitureBanner from "../../../assets/images/furniture-banner.png";
// import Approve from "../../../assets/images/Approve.svg";
// import TestimonialSec from "../../property/testimonialSec/TestimonialSec";
// import FurnitureBackImg from "../../../assets/images/furniture-back.png";

// import "react-datepicker/dist/react-datepicker.css";
// import "../../furnitureFront/Furniture.css";

// const CustomiseFurniture = () => {
//   const { user } = useUserState();
//   const navigate = useNavigate();
//   const location = useLocation();
//   const [furDetailModal, setFurDetailModal] = useState(false);
//   const [particularFurInfo, setParticularFurInfo] = useState({});
//   const [furCompaniesList, setFurCompaniesList] = useState([]);
//   const [companyListLoader, setCompanyListLoader] = useState(false);
//   const [furList, setFurList] = useState([]);
//   const [furListLoader, setFurListLoader] = useState(false);
//   const [selectedOption, setSelectedOption] = useState(null);
//   const [selectedFurniture, setSelectedFurniture] = useState([]);
//   const [housewareList, setHousewareList] = useState([]);
//   const [totalPrice, setTotalPrice] = useState(null);
//   const [loader, setLoader] = useState(false);
//   const houseDetail=location.state.houseDetail;
//   console.log('houseDetail',houseDetail);
//   const headers = {
//     Authorization: user?.token,
//   };

//   const fetchCompaniesList = async () => {
//     const apiUrl = `${
//       import.meta.env.VITE_APP_BASE_URL
//     }/api/user/getAllCompany/furniture_company`;
//     setCompanyListLoader(true);
//     try {
//       const res = await axios.get(apiUrl, {
//         headers: headers,
//       });
//       setFurCompaniesList(res?.data?.data);
//       setCompanyListLoader(false);
//     } catch (error) {
//       console.log(
//         "Error while fetching furniture company List",
//         error?.message
//       );
//       setCompanyListLoader(false);
//     }
//   };

//   const fetchAllfurnitureList = async (id, array1) => {
//     const apiUrl = `${
//       import.meta.env.VITE_APP_BASE_URL
//     }/api/furniture/get-list?categoryId=&companyId=${id}`;
//     try {
//       debugger
//       const res = await axios.get(apiUrl, {
//         headers: headers,
//       });
//       const mergedArray = [...array1, ...res?.data?.data];
//       const uniqueArray = mergedArray?.filter(
//         (item, index, self) =>
//           index === self?.findIndex((t) => t?.id === item?.id)
//       );
//      const updatedArray = uniqueArray?.map((item) => ({
//        ...item,
//      selected: array1?.some((arrItem) => arrItem?.id === item?.id),
//      quantity:
//      array1?.find((arrItem) => arrItem?.id === item?.id)?.quantity || 1,
//       }));

//       setSelectedFurniture(updatedArray?.filter((item) => item.selected));
//       setFurList(updatedArray);
//       setFurListLoader(false);
//     } catch (error) {
//       console.error(
//         "Error while fetching furniture on behalf of company:",
//         error?.message
//       );
//       setFurListLoader(false);
//     }
//   };

// const handleChooseCompany = async (id) => {
//   setSelectedOption(id);
//   const apiUrl = `${
//     import.meta.env.VITE_APP_BASE_URL
//   }/api/furniture/get-list?categoryId=${
//     location?.state?.furPlanId
//   }&companyId=${id}&leasePeriod=${houseDetail?.min_lease_period}&bedroom=${
//     houseDetail?.bedroom_no
//   }&bathroom=${houseDetail?.bathroom_no}`;
//   setFurListLoader(true);
//   try {
//     const res = await axios.get(apiUrl, { headers });
//     const furnitureData = res?.data?.data || [];
//     await fetchAllfurnitureList(id, furnitureData);
//   } catch (error) {
//     console.error(
//       "Error while fetching furniture on behalf of company:",
//       error?.response?.data?.message || error.message
//     );
//   } finally {
//     // always stop loader, success or failure
//     setFurListLoader(false);
//   }
// };

//   const addTwoDays = (date) => {
//     if (date) {
//       date.setDate(date.getDate() + 2); // Add two days
//       return date.toLocaleDateString("en-US");
//     }
//   };

//   const handleFurCheckbox = (furniture) => {
//     const isSelected = selectedFurniture.some(
//       (item) => item.id === furniture.id
//     );
//     if (!isSelected) {
//       setSelectedFurniture([...selectedFurniture, {...furniture, quantity: 1}]);
//     } else {
//       const updatedFurnitureList = selectedFurniture.filter(
//         (item) => item.id !== furniture.id
//       );
//       setSelectedFurniture(updatedFurnitureList);
//     }
//   };

//   const decrementQuantity = (i) => {
//     const updatedItems = [...selectedFurniture];
//     if (updatedItems[i]?.quantity > 1) {
//       updatedItems[i].quantity -= 1;
//       setSelectedFurniture(updatedItems);
//     }
//   };

//   const incrementQuantity = (i) => {
//     const updatedItems = [...selectedFurniture];
//     updatedItems[i].quantity += 1;
//     setSelectedFurniture(updatedItems);
//   };

//   const handleProceed = async () => {
//     const finalArray = [];
//     if (selectedFurniture?.length > 0) {
//       for (let i = 0; i < selectedFurniture?.length; i++) {
//         const element = selectedFurniture[i];
//         const newObj = {
//           furniture_category_id: element.furniture_category_id,
//           house_id: location?.state?.houseId,
//           furniture_id: element?.id,
//           quantity: element?.quantity,
//         };
//         finalArray.push(newObj);
//       }
//     }
//     let payload = {
//       cartId: location?.state?.cartId,
//       furData: finalArray,
//       dataType: "furniture",
//     };

//     const apiUrl = `${import.meta.env.VITE_APP_BASE_URL}/api/cart/update-cart/${
//       location?.state?.cartId
//     }`;

//     setLoader(true);
//     try {
//       const res = await axios.put(apiUrl, payload, {
//         headers: headers,
//       });
//       setLoader(false);
//       if (res?.data?.statusCode === 200) {
//         navigate(
//           `/cleaning-package?cart=${location?.state?.cartId}&&house=${location?.state?.houseId}`,
//           {
//             state: {
//               houseId: location?.state?.houseId,
//               cartId: location?.state?.cartId,
//               startDate: location?.state?.startDate,
//               endDate: location?.state?.endDate,
//                storeId: location?.state?.storeId,
//             },
//           }
//         );
//       }
//     } catch (error) {
//       setLoader(false);
//       console.log("Error while hitting update cart API", error);
//     }
//   };

//   useEffect(() => {
//     const totalPriceValue = selectedFurniture.reduce(
//       (total, fur) => total + fur.price * fur.quantity,
//       0
//     );
//     setTotalPrice(totalPriceValue);
//   }, [selectedFurniture]);

//   useEffect(() => {
//     handleChooseCompany(location?.state?.companyId);
//     fetchAllfurnitureList(location?.state?.companyId);
//   }, [user?.token]);

//   useEffect(() => {
//     fetchCompaniesList();
//   }, [user?.token]);

//   useEffect(() => {
//     if (location?.state?.companyId) {
//       setSelectedOption(location?.state?.companyId);
//     }
//   }, [location?.state?.companyId]);

//   useEffect(() => {
//     if (
//       !location?.state?.houseId ||
//       !location?.state?.cartId ||
//       !location?.state?.furPlan ||
//       !location?.state?.furPlanId ||
//       !location?.state?.companyId ||
//       !location?.state?.startDate ||
//       !location?.state?.endDate
//     ) {
//       navigate("/");
//     }
//   }, []);

//   useEffect(() => {
//     window.scrollTo({
//       top: 0,
//       behavior: "instant",
//     });
//   }, []);
// console.log('selectedFurniture',selectedFurniture);

//   return (
//     <Fragment>
//       <div className="banner-section furniture-main">
//         <img src={furnitureBanner} alt="furnitureBanner" />
//         <div className="search-home my-container">
//           <div className="furniture-about">
//             <div className="furniture-img">
//               <img src={aboutUs} />
//             </div>
//             <div className="fur-about-content">
//               <h2>Quality Furniture Store On Your Specific Area</h2>

//               <p>
//                 We build and activate brands through cultural insight,
//                 strvision, and the power of emotion across every.
//               </p>
//               <div className="overview-amenities">
//                 <ul>
//                   <li>
//                     <img src={tickmark} />
//                     Mix and match colors, sizes, and designs
//                   </li>
//                   <li>
//                     <img src={tickmark} />
//                     Top quality prints using the latest technology
//                   </li>
//                 </ul>
//               </div>
//             </div>
//           </div>
//           {/* <div className="negotiate-content">
//             <h3>
//               {location?.state?.furPlan} Package Offer from different trusted
//               partners
//             </h3>
//             <div className="row">
//               {companyListLoader && <Spinner />}
//               {furCompaniesList &&
//                 furCompaniesList?.length > 0 &&
//                 furCompaniesList?.map((company) => (
//                   <div
//                     key={company?.id}
//                     className={`col-12 col-lg-3 col-md-3 ${
//                       selectedOption === company?.id ? "active-company" : ""
//                     }`}
//                   >
//                     <div className="trusted-part-title">
//                       <h2>{company?.furniture_company}</h2>
//                     </div>
//                     <div className="trusted-part-radio">
//                       <div className="form-check">
//                         <input
//                           className="form-check-input"
//                           type="radio"
//                           name="flexRadioDefault"
//                           id={company?.id}
//                           value={company.id}
//                           checked={selectedOption === company?.id}
//                           onChange={(e) => handleChooseCompany(e.target.value)}
//                         />
//                         <span className="furn-off-num">15% OFF</span>
//                         <label
//                           className="form-check-label"
//                           htmlFor={company?.id}
//                         />
//                       </div>
//                       <div className="furniture-new-price">
//                         <p>
//                           $230<span>$220</span>
//                         </p>
//                       </div>
//                     </div>
//                   </div>
//                 ))}
//             </div>
//           </div> */}
//         </div>
//       </div>

//       {location?.state?.companyId && (
//         <>
//           <div className="dilivery-time-sec">
//             <div className="container-fluid my-container">
//               <div className="row">
//                 <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
//                   <div className="search-header">
//                     <h2>Your Delivery Date & Time</h2>
//                     <p>
//                       <i className="fa fa-info" aria-hidden="true"></i>{" "}
//                       Furniture will be delivered on the date{" "}
//                       {addTwoDays(new Date(location?.state?.startDate))}
//                     </p>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//           <div className="furniture-plan">
//             <div className="container-fluid my-container">
//               <div className="row">
//                 <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
//                   <div className="search-header">
//                     <h2>Customize your package</h2>
//                   </div>
//                 </div>
//               </div>
//               <div className="row">
//                 <div className="col-xs-12 col-sm-12 col-md-12 col-lg-9">
//                   <div className="row">
//                     {furListLoader && <Spinner />}
//                     {furList &&
//                       furList?.length > 0 &&
//                       furList?.map((furniture, index) => (
//                         <div
//                           className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-4 col-xxl-4"
//                           key={index}
//                         >
//                           <div className="property-inner furniture-custom">
//                             <div className="custom-fur-img">
//                               <a
//                                 className="btn btn-primary"
//                                 onClick={() => {
//                                   setFurDetailModal(true);
//                                   setParticularFurInfo(furniture);
//                                 }}
//                               >
//                                 <i className="fa fa-info"></i>
//                               </a>
//                               <img
//                                 src={
//                                   import.meta.env.VITE_APP_BASE_URL +
//                                   furniture?.imageUrl
//                                 }
//                                 onError={(e) => {
//                                   e.target.src = FurnitureBackImg;
//                                 }}
//                               />
//                             </div>
//                             <div className="custom-fur-content">
//                               <div className="form-check">
//                                 <input
//                                   className="form-check-input"
//                                   type="checkbox"
//                                   id={index}
//                                   disabled={furniture?.selected}
//                                   checked={selectedFurniture.some(
//                                     (item) => item?.id === furniture?.id
//                                   )}
//                                   onChange={() => handleFurCheckbox(furniture)}
//                                 />
//                                 <label
//                                   className="form-check-label"
//                                   htmlFor={index}
//                                 >
//                                   {furniture?.name}
//                                 </label>
//                               </div>
//                               <p className="price-sec">${furniture?.price}</p>
//                             </div>
//                           </div>
//                         </div>
//                       ))}
//                   </div>
//                 </div>

//                 <div className="col-xs-12 col-sm-12 col-md-12 col-lg-3">
//                   <div className="add-furniture-item">
//                     <ul>
//                       {selectedFurniture &&
//                         selectedFurniture?.length > 0 &&
//                         selectedFurniture?.map((fur, i) => (
//                           <li key={i}>
//                             <div className="delux_item">
//                               <div className="book_item_img">
//                                 <img
//                                   src={
//                                     import.meta.env.VITE_APP_BASE_URL +
//                                     fur?.imageUrl
//                                   }
//                                   alt={fur?.name}
//                                   onError={(e) => {
//                                     e.target.src = FurnitureBackImg;
//                                   }}
//                                 />
//                                 <div className="zunkel_cont">
//                                   <p>{fur?.name}</p>
//                                   <div className="swatch-head">
//                                     <span className="title-swatch">Color</span>{" "}
//                                     <span
//                                       className="color-swatch"
//                                       style={{
//                                         background: `${fur?.color}`,
//                                       }}
//                                     ></span>
//                                   </div>
//                                 </div>
//                               </div>

//                               <div className="zunkel_price_head">
//                                 <div className="add-item">
//                                   <button
//                                     type="button"
//                                     onClick={() => decrementQuantity(i)}
//                                   >
//                                     <i
//                                       className="fa fa-minus"
//                                       aria-hidden="true"
//                                     ></i>
//                                   </button>
//                                   <input
//                                     type="text"
//                                     className="qty"
//                                     value={fur?.quantity}
//                                     onChange={(e) =>
//                                       setQuantityInput(e.target.value)
//                                     }
//                                     readOnly
//                                   />
//                                   <button
//                                     type="button"
//                                     onClick={() => incrementQuantity(i)}
//                                   >
//                                     <i
//                                       className="fa fa-plus"
//                                       aria-hidden="true"
//                                     ></i>
//                                   </button>
//                                 </div>

//                                 <div className="zunkel_price">
//                                   <p>${fur?.price * fur?.quantity}</p>
//                                 </div>
//                               </div>
//                             </div>
//                           </li>
//                         ))}
//                     </ul>

//                     <div className="total-sec">
//                       <p>
//                         Total <span>${totalPrice}</span>
//                       </p>
//                     </div>
//                     <button
//                       type="button"
//                       className="druyp-btn"
//                       disabled={loader}
//                       onClick={handleProceed}
//                     >
//                       Proceed {loader && <Spinner />}
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </>
//       )}

//       <TestimonialSec />

//       <Modal
//         size="lg"
//         show={furDetailModal}
//         onHide={() => setFurDetailModal(false)}
//         aria-labelledby="contained-modal-title-vcenter"
//         centered
//       >
//         <Modal.Body>
//           <div className="negotiate-content">
//             <div className="container">
//               <div className="row">
//                 <div className="col-12 col-lg-4 col-md-4">
//                   <img
//                     src={
//                       import.meta.env.VITE_APP_BASE_URL +
//                       particularFurInfo?.imageUrl
//                     }
//                     alt={particularFurInfo?.name}
//                     onError={(e) => {
//                       e.target.src = FurnitureBackImg;
//                     }}
//                   />
//                 </div>
//                 <div className="col-12 col-lg-8 col-md-8">
//                   <div className="furniture-content">
//                     <h3>{particularFurInfo?.name}</h3>
//                     <p className="furn-price">${particularFurInfo?.price} </p>
//                     <div className="furniture-content Specific">
//                       <h3>Specifications</h3>
//                       <ul>
//                         <li>
//                           <img src={Approve} />
//                           <div className="Specific-content">
//                             <h3>Brand Name</h3>
//                             <p>{particularFurInfo?.brand}</p>
//                           </div>
//                         </li>
//                         <li>
//                           <img src={Approve} />
//                           <div className="Specific-content">
//                             <h3>Color</h3>
//                             <span
//                               className="color-swatch"
//                               style={{
//                                 background: `${particularFurInfo?.color}`,
//                               }}
//                             ></span>
//                           </div>
//                         </li>
//                         <li>
//                           <img src={Approve} />
//                           <div className="Specific-content">
//                             <h3>Material</h3>
//                             <p>{particularFurInfo?.material}</p>
//                           </div>
//                         </li>
//                       </ul>
//                     </div>
//                   </div>
//                 </div>
//                 <div className="col-12 col-lg-12 col-md-12">
//                   <div className="furniture-content dicription">
//                     <h3>Description</h3>
//                     <p>{particularFurInfo?.description}</p>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </Modal.Body>
//       </Modal>
//     </Fragment>
//   );
// };

// export default CustomiseFurniture;

"use client";

import { Fragment, useState, useEffect } from "react";
import { Modal, Spinner } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { useUserState } from "../../../Contexts/UserContext";
import aboutUs from "../../../assets/images/about-us.png";
import tickmark from "../../../assets/images/tickmark.svg";
import furnitureBanner from "../../../assets/images/furniture-banner.png";
import Approve from "../../../assets/images/Approve.svg";
import TestimonialSec from "../../property/testimonialSec/TestimonialSec";
import FurnitureBackImg from "../../../assets/images/furniture-back.png";
import PackageSummaryModal from "../customisePlan/FurniturePackageTotal";
import "react-datepicker/dist/react-datepicker.css";
import "../../furnitureFront/Furniture.css";
import { Select } from "antd";
import "antd/dist/reset.css";

const CustomiseFurniture = () => {
  const { user } = useUserState();
  const navigate = useNavigate();
  const location = useLocation();
  const [furDetailModal, setFurDetailModal] = useState(false);
  const [particularFurInfo, setParticularFurInfo] = useState({});
  const [furCompaniesList, setFurCompaniesList] = useState([]);
  const [companyListLoader, setCompanyListLoader] = useState(false);
  const [furList, setFurList] = useState([]);
  const [furListLoader, setFurListLoader] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [selectedFurniture, setSelectedFurniture] = useState([]);
  const [housewareList, setHousewareList] = useState([]);
  const [totalPrice, setTotalPrice] = useState(null);
  const [loader, setLoader] = useState(false);
  const houseDetail = location.state.houseDetail;
  const alreadySelectedFur = location.state.allFurPkgCart || [];
  const SelectedFurniture = location.state.furList || [];
  const SelectedHouseItem = location.state.housewareItems || [];
  const deliveryPriceFromState = location.state.deliveryPrice || 0;
  const [openPackageDetailModal, setOpenPackageDetailModal] = useState(false);
  // console.log("houseDetail", houseDetail)
  const headers = {
    Authorization: user?.token,
  };

  const splitFurnitureAndHouseware = (list = []) =>
    list.reduce(
      (acc, item) => {
        if (item?.type?.toLowerCase() === "houseware")
          acc.houseWarePackage.push(item);
        else acc.furnitureData.push(item);
        return acc;
      },
      { houseWarePackage: [], furnitureData: [] }
    );
  const { furnitureData, houseWarePackage } =
    splitFurnitureAndHouseware(alreadySelectedFur);
  const fetchCompaniesList = async () => {
    const apiUrl = `${
      import.meta.env.VITE_APP_BASE_URL
    }/api/user/getAllCompany/furniture_company`;
    setCompanyListLoader(true);
    try {
      const res = await axios.get(apiUrl, {
        headers: headers,
      });
      setFurCompaniesList(res?.data?.data);
      setCompanyListLoader(false);
    } catch (error) {
      console.log(
        "Error while fetching furniture company List",
        error?.message
      );
      setCompanyListLoader(false);
    }
  };

  const fetchAllfurnitureList = async (id, array1) => {
    const apiUrl = `${
      import.meta.env.VITE_APP_BASE_URL
    }/api/furniture/get-list?categoryId=&companyId=${id}`;
    try {
      const res = await axios.get(apiUrl, {
        headers: headers,
      });
      const mergedArray = [...array1, ...res?.data?.data];
      const uniqueArray = mergedArray?.filter(
        (item, index, self) =>
          index === self?.findIndex((t) => t?.id === item?.id)
      );
      const updatedArray = uniqueArray?.map((item) => ({
        ...item,
        selected: array1?.some((arrItem) => arrItem?.id === item?.id),
        quantity:
          array1?.find((arrItem) => arrItem?.id === item?.id)?.quantity || 1,
      }));

      setSelectedFurniture(updatedArray?.filter((item) => item.selected));
      setFurList(updatedArray);
      setFurListLoader(false);
    } catch (error) {
      console.error(
        "Error while fetching furniture on behalf of company:",
        error?.message
      );
      setFurListLoader(false);
    }
  };

  const handleChooseCompany = async (id) => {
    setSelectedOption(id);
    const apiUrl = `${
      import.meta.env.VITE_APP_BASE_URL
    }/api/furniture/get-list?categoryId=${
      location?.state?.furPlanId
    }&companyId=${id}&leasePeriod=${houseDetail?.min_lease_period}&bedroom=${
      houseDetail?.bedroom_no
    }&bathroom=${houseDetail?.bathroom_no}`;
    setFurListLoader(true);
    try {
      const res = await axios.get(apiUrl, { headers });
      const furnitureData = res?.data?.data || [];
      await fetchAllfurnitureList(id, furnitureData);
    } catch (error) {
      console.error(
        "Error while fetching furniture on behalf of company:",
        error?.response?.data?.message || error.message
      );
    } finally {
      // always stop loader, success or failure
      setFurListLoader(false);
    }
  };

  const addTwoDays = (date) => {
    if (date) {
      date.setDate(date.getDate() + 2); // Add two days
      return date.toLocaleDateString("en-US");
    }
  };

  const handleFurCheckbox = (furniture) => {
    const isSelected = selectedFurniture.some(
      (item) => item.id === furniture.id
    );
    if (!isSelected) {
      setSelectedFurniture([
        ...selectedFurniture,
        { ...furniture, quantity: 1 },
      ]);
    } else {
      const updatedFurnitureList = selectedFurniture.filter(
        (item) => item.id !== furniture.id
      );
      setSelectedFurniture(updatedFurnitureList);
    }
  };

  const decrementQuantity = (i) => {
    const updatedItems = [...selectedFurniture];
    if (updatedItems[i]?.selected) return; // package item: lock quantity
    if (updatedItems[i]?.quantity > 1) {
      updatedItems[i].quantity -= 1;
      setSelectedFurniture(updatedItems);
    }
  };

  const incrementQuantity = (i) => {
    const updatedItems = [...selectedFurniture];
    if (updatedItems[i]?.selected) return; // package item: lock quantity
    updatedItems[i].quantity += 1;
    setSelectedFurniture(updatedItems);
  };

  const handleProceed = async () => {
    const finalArray = [];
    if (selectedFurniture?.length > 0) {
      for (let i = 0; i < selectedFurniture?.length; i++) {
        const element = selectedFurniture[i];
        const newObj = {
          furniture_category_id: element.furniture_category_id,
          house_id: location?.state?.houseId,
          furniture_id: element?.id,
          quantity: element?.quantity,
        };
        finalArray.push(newObj);
      }
    }

    const furnitureMap = new Map();
    alreadySelectedFur.forEach((item) => {
      furnitureMap.set(item.furniture_id, { ...item });
    });
    finalArray.forEach((item) => {
      const existing = furnitureMap.get(item.furniture_id);
      if (existing) {
        furnitureMap.set(item.furniture_id, {
          ...existing,
          quantity: item.quantity ?? existing.quantity,
          is_package_item:
            existing.is_package_item || item.is_package_item || false,
        });
      } else {
        furnitureMap.set(item.furniture_id, { ...item });
      }
    });
    const mergedArray = Array.from(furnitureMap.values());
    const payload = {
      cartId: location?.state?.cartId,
      // furData: [...finalArray, ...alreadySelectedFur],
      furData: mergedArray,
      dataType: "furniture",
    };

    const apiUrl = `${import.meta.env.VITE_APP_BASE_URL}/api/cart/update-cart/${
      location?.state?.cartId
    }`;

    setLoader(true);
    try {
      const res = await axios.put(apiUrl, payload, {
        headers: headers,
      });
      setLoader(false);
      if (res?.data?.statusCode === 200) {
        navigate(
          `/cleaning-package?cart=${location?.state?.cartId}&&house=${location?.state?.houseId}`,
          {
            state: {
              houseId: location?.state?.houseId,
              cartId: location?.state?.cartId,
              startDate: location?.state?.startDate,
              endDate: location?.state?.endDate,
              storeId: location?.state?.storeId,
            },
          }
        );
      }
    } catch (error) {
      setLoader(false);
      console.log("Error while hitting update cart API", error);
    }
  };
  console.log("selectedFurniture", selectedFurniture);

  // Grouped source options (from furList) and current selections (from selectedFurniture)
  const packageItems = furList.filter((i) => i?.selected);
  const addOnFurnitureOptions = furList.filter(
    (i) =>
      !i?.selected &&
      (i?.type === "furniture" || i?.type === null || i?.type === undefined)
  );
  const addOnHousewareOptions = furList.filter(
    (i) => !i?.selected && i?.type === "houseware"
  );

  // Values for controlled multi-selects
  const selectedAddOnFurnitureIds = selectedFurniture
    .filter(
      (i) =>
        !i?.selected &&
        (i?.type === "furniture" || i?.type === null || i?.type === undefined)
    )
    .map((i) => String(i.id));

  const selectedAddOnHousewareIds = selectedFurniture
    .filter((i) => !i?.selected && i?.type === "houseware")
    .map((i) => String(i.id));

  // Helpers to sync selection while keeping package items intact
  const syncAddOnSelection = (ids, type) => {
    setSelectedFurniture((prev) => {
      const keep = prev.filter(
        (it) =>
          it?.selected ||
          (type === "furniture"
            ? it?.type === "houseware"
            : it?.type === "furniture" ||
              it?.type === null ||
              it?.type === undefined)
      );

      const sourceList =
        type === "furniture" ? addOnFurnitureOptions : addOnHousewareOptions;

      const nextOfType = ids
        .map((id) => {
          const base = sourceList.find((o) => String(o.id) === String(id));
          if (!base) return null;
          const existed = prev.find((p) => String(p.id) === String(id));
          return existed
            ? { ...base, quantity: existed.quantity }
            : { ...base, quantity: 1 };
        })
        .filter(Boolean);

      return [...keep, ...nextOfType];
    });
  };

  const onFurnitureMultiChange = (values) => {
    syncAddOnSelection(values, "furniture");
  };
  const onHousewareMultiChange = (values) => {
    syncAddOnSelection(values, "houseware");
  };

  // Aggregated package price for display
  const packageTotal = packageItems.reduce(
    (sum, it) => sum + Number(it.price) * Number(it.quantity || 1),
    0
  );
  const addOnItems = selectedFurniture.filter((i) => !i?.selected);

  useEffect(() => {
    const totalPriceValue = selectedFurniture.reduce(
      (total, fur) => total + fur.price * fur.quantity,
      0
    );
    setTotalPrice(totalPriceValue);
  }, [selectedFurniture]);

  useEffect(() => {
    handleChooseCompany(location?.state?.companyId);
    fetchAllfurnitureList(location?.state?.companyId);
  }, [user?.token]);

  useEffect(() => {
    fetchCompaniesList();
  }, [user?.token]);

  useEffect(() => {
    if (location?.state?.companyId) {
      setSelectedOption(location?.state?.companyId);
    }
  }, [location?.state?.companyId]);

  useEffect(() => {
    if (
      !location?.state?.houseId ||
      !location?.state?.cartId ||
      !location?.state?.furPlan ||
      !location?.state?.furPlanId ||
      !location?.state?.companyId ||
      !location?.state?.startDate ||
      !location?.state?.endDate
    ) {
      navigate("/");
    }
  }, []);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "instant",
    });
  }, []);

  console.log("selectedFurniture", selectedFurniture);

  return (
    <Fragment>
      <div className="banner-section furniture-main">
        <img
          src={furnitureBanner || "/placeholder.svg"}
          alt="furnitureBanner"
        />
        <div className="search-home my-container">
          <div className="furniture-about">
            <div className="furniture-img">
              <img src={aboutUs || "/placeholder.svg"} />
            </div>
            <div className="fur-about-content">
              <h2>Quality Furniture Store On Your Specific Area</h2>
              <p>
                We build and activate brands through cultural insight,
                strvision, and the power of emotion across every.
              </p>
              <div className="overview-amenities">
                <ul>
                  <li>
                    <img src={tickmark || "/placeholder.svg"} />
                    Mix and match colors, sizes, and designs
                  </li>
                  <li>
                    <img src={tickmark || "/placeholder.svg"} />
                    Top quality prints using the latest technology
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      {location?.state?.companyId && (
        <>
          <div className="dilivery-time-sec">
            <div className="container-fluid my-container">
              <div className="row">
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                  <div className="search-header">
                    <h2>Your Delivery Date & Time</h2>
                    <p>
                      <i className="fa fa-info" aria-hidden="true"></i>{" "}
                      Furniture will be delivered on the date{" "}
                      {addTwoDays(new Date(location?.state?.startDate))}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="furniture-plan">
            <div className="container-fluid my-container">
              <div className="row">
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-9">
                  <div className="mb-4">
                    <h5 className="mb-2">Package (included)</h5>
                    {furListLoader && <Spinner />}
                    {packageItems.length === 0 && (
                      <p className="text-muted">No package items.</p>
                    )}
                    {packageItems.length > 0 && (
                      <>
                        <ul className="list-unstyled mb-2">
                          {packageItems.map((item) => (
                            <li key={item.id} className="py-1">
                              {item.name}
                            </li>
                          ))}
                        </ul>
                        <div className="d-flex justify-content-between align-items-center border-top pt-2">
                          <span className="fw-semibold">
                            Package total ({packageItems.length} items)
                          </span>
                          <span className="fw-semibold">${packageTotal}</span>
                        </div>
                        <p className="text-muted mt-2" style={{ fontSize: 12 }}>
                          Package items are fixed and cannot be modified.
                        </p>
                      </>
                    )}
                  </div>

                  <div className="mb-4">
                    <h5 className="mb-2">Pick Add‑on Items</h5>

                    <div className="mb-3">
                      <label className="form-label fw-semibold">
                        Select Furniture items
                      </label>
                      <Select
                        mode="multiple"
                        style={{ width: "100%" }}
                        placeholder="Select Furniture add-ons"
                        value={selectedAddOnFurnitureIds}
                        onChange={onFurnitureMultiChange}
                        options={addOnFurnitureOptions.map((o) => ({
                          label: `${o.name} — $${o.price}`,
                          value: String(o.id),
                        }))}
                      />
                    </div>

                    <div className="mb-3">
                      <label className="form-label fw-semibold">
                        Select Houseware items
                      </label>
                      <Select
                        mode="multiple"
                        style={{ width: "100%" }}
                        placeholder="Select Houseware add-ons"
                        value={selectedAddOnHousewareIds}
                        onChange={onHousewareMultiChange}
                        options={addOnHousewareOptions.map((o) => ({
                          label: `${o.name} — $${o.price}`,
                          value: String(o.id),
                        }))}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-3">
                  <div className="add-furniture-item">
                    <ul>
                      {/* Package row (aggregated) */}
                      {packageItems.length > 0 && (
                        <li>
                          <div className="delux_item">
                            <div className="zunkel_cont">
                              <p className="mb-1 fw-semibold">
                                Package items ({packageItems.length})
                              </p>
                              {/* <p className="text-muted" style={{ fontSize: 12 }}>
                                Fixed items, quantity locked
                              </p> */}
                            </div>
                            <div className="zunkel_price_head">
                              <div className="add-item">
                                {/* <button type="button" disabled title="Package item cannot be changed">
                                  <i className="fa fa-minus" aria-hidden="true"></i>
                                </button>
                                <input type="text" className="qty" value={1} readOnly />
                                <button type="button" disabled title="Package item cannot be changed">
                                  <i className="fa fa-plus" aria-hidden="true"></i>
                                </button> */}
                              </div>
                              <div className="zunkel_price">
                                <p>${packageTotal}</p>
                              </div>
                            </div>
                          </div>
                        </li>
                      )}

                      {/* Add-on items */}
                      {addOnItems.map((fur, i) => (
                        <li key={fur.id}>
                          <div className="delux_item">
                            <div className="zunkel_cont">
                              <p className="mb-1">{fur?.name}</p>
                              {fur?.color ? (
                                <div className="swatch-head">
                                  <span className="title-swatch">Color</span>{" "}
                                  <span
                                    className="color-swatch"
                                    style={{ background: `${fur?.color}` }}
                                  ></span>
                                </div>
                              ) : null}
                            </div>
                            <div className="zunkel_price_head">
                              <div className="add-item">
                                <button
                                  type="button"
                                  onClick={() =>
                                    decrementQuantity(
                                      selectedFurniture.indexOf(fur)
                                    )
                                  }
                                >
                                  <i
                                    className="fa fa-minus"
                                    aria-hidden="true"
                                  ></i>
                                </button>
                                <input
                                  type="text"
                                  className="qty"
                                  value={fur?.quantity}
                                  readOnly
                                />
                                <button
                                  type="button"
                                  onClick={() =>
                                    incrementQuantity(
                                      selectedFurniture.indexOf(fur)
                                    )
                                  }
                                >
                                  <i
                                    className="fa fa-plus"
                                    aria-hidden="true"
                                  ></i>
                                </button>
                              </div>
                              <div className="zunkel_price">
                                <p>
                                  ${Number(fur?.price) * Number(fur?.quantity)}
                                </p>
                              </div>
                            </div>
                          </div>
                        </li>
                      ))}
                    </ul>

                    <div className="total-sec">
                      <p>
                        Total <span>${totalPrice}</span>
                      </p>
                    </div>
                    <button
                      type="button"
                      className="druyp-btn"
                      disabled={loader}
                      // onClick={handleProceed}
                      onClick={() => setOpenPackageDetailModal(true)}
                    >
                      Proceed {loader && <Spinner />}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      <TestimonialSec />
      <PackageSummaryModal
        open={openPackageDetailModal}
        onClose={() => setOpenPackageDetailModal(false)}
        onProceed={handleProceed}
        furniture={SelectedFurniture}
        houseware={SelectedHouseItem}
        deliveryPrice={deliveryPriceFromState}
        packageName={location?.state?.furPlan}
        addOnItems={addOnItems}
      />
      <Modal
        size="lg"
        show={furDetailModal}
        onHide={() => setFurDetailModal(false)}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body>
          <div className="negotiate-content">
            <div className="container">
              <div className="row">
                <div className="col-12 col-lg-4 col-md-4">
                  <img
                    src={
                      getSafeUrl(particularFurInfo?.imageUrl) || "/placeholder.svg"
                    }
                    alt={particularFurInfo?.name}
                    onError={(e) => {
                      e.target.src = FurnitureBackImg;
                    }}
                  />
                </div>
                <div className="col-12 col-lg-8 col-md-8">
                  <div className="furniture-content">
                    <h3>{particularFurInfo?.name}</h3>
                    <p className="furn-price">${particularFurInfo?.price} </p>
                    <div className="furniture-content Specific">
                      <h3>Specifications</h3>
                      <ul>
                        <li>
                          <img src={Approve || "/placeholder.svg"} />
                          <div className="Specific-content">
                            <h3>Brand Name</h3>
                            <p>{particularFurInfo?.brand}</p>
                          </div>
                        </li>
                        <li>
                          <img src={Approve || "/placeholder.svg"} />
                          <div className="Specific-content">
                            <h3>Color</h3>
                            <span
                              className="color-swatch"
                              style={{
                                background: `${particularFurInfo?.color}`,
                              }}
                            ></span>
                          </div>
                        </li>
                        <li>
                          <img src={Approve || "/placeholder.svg"} />
                          <div className="Specific-content">
                            <h3>Material</h3>
                            <p>{particularFurInfo?.material}</p>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-lg-12 col-md-12">
                  <div className="furniture-content dicription">
                    <h3>Description</h3>
                    <p>{particularFurInfo?.description}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </Fragment>
  );
};

export default CustomiseFurniture;
